// utilities.js
import { colors } from "./theme";

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

/**
 * Utility styles
 * Mobile-first, safe defaults
 */
export const utils = {
  /**
   * Perfect center alignment
   * Safe everywhere
   */
  centerFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  /**
   * Row on desktop → column on mobile
   * This is intentionally opinionated for mobile UX
   */
  flexRow: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "stretch" : "center",
    justifyContent: "space-between",
    gap: isMobile ? 12 : 0,
    width: "100%",
  },

  /**
   * Column utility with responsive spacing
   */
  flexCol: {
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? 8 : 12,
    width: "100%",
  },

  /**
   * Text helpers
   */
  mutedText: {
    color: colors.textMuted,
  },

  /**
   * Row that should NEVER stack
   * Use when horizontal layout is mandatory
   * (icons + text, compact headers, breadcrumbs)
   */
  flexRowNoWrap: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },

  /**
   * Button group utility
   * Full-width buttons on mobile
   * Inline buttons on desktop
   */
  buttonRow: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 12,
    width: "100%",
  },

  /**
   * Visually hidden but SEO-accessible
   * Useful for screen readers & headings
   */
  visuallyHidden: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
  },

  /**
   * Common grid layouts
   */
  grid2: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
    gap: isMobile ? 12 : 16,
  },

  grid3: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
    gap: isMobile ? 12 : 16,
  },

  /**
   * Label block for forms
   */
  labelBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    fontSize: 14,
    fontWeight: 500,
  },

  /**
   * Actions row (buttons at the end)
   */
  actionsRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 8,
  },
};
